import useMediaQuery from "./../../../hooks/useMediaQuery";
import Link from "./components/Link";
import {
  Nav,
  NavContainer,
  NavLinkContainer,
} from "./components/style";
import Language from "./components/Language";
import SideMenu from "./components/sideMenu/SideMenu";

const Navbar = ({ selectedPage, setSelectedPage, language, setLanguage }) => {
  const desktop = useMediaQuery("(min-width: 1024px)");
  const small = useMediaQuery("(max-width: 768px)");

  return (
    <Nav>
      <NavContainer>
        {desktop && (
          <NavLinkContainer>
            <Link
              page="home"
              label={language === "pt" ? "início" : "home"}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
            <Link
              page="about"
              label={language === "pt" ? "sobre" : "about"}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
            <Link
              page="skills"
              label={language === "pt" ? "habilidades" : "skills"}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
            <Link
              page="projects"
              label={language === "pt" ? "projetos" : "projects"}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
            <Link
              page="contact"
              label={language === "pt" ? "contato" : "contact"}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
            />
            <Language language={language} setLanguage={setLanguage} />
          </NavLinkContainer>
        )}
        {small && (
          <>
            <SideMenu
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
              language={language}
              setLanguage={setLanguage}
            />
            <Language language={language} setLanguage={setLanguage} />
          </>
        )}
      </NavContainer>
    </Nav>
  );
};

export default Navbar;
